import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
  async getQueryBuilderTypesFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.queryBuilderTypesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getQueryBuilderTypesFromServer][Store][Error occured while gettingstorage report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getQueryBuildsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.queryBuilderUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        context.commit("setQueryBuilderTypesInfo", resp.data.report_types);
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getQueryBuildsFromServer][Store][Error occured while getting query list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateQueryBuilds(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.queryBuilderUrl+"/"+payload.report_id, payload.params);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateQueryBuilds][Store][User add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateQueryBuilds][Store][Error occured while adding user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          try{
            error.response.data.statusCode = error.response.status
            return error.response.data
          }catch(e){
            throw new Error(e);
          }
        }
      }
      return {}
    }

  },
  async deleteQueryBuilds(context, payload = {}) {
    try {
      let resp = await axios.delete(`${Constants.queryBuilderUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        context.commit("setQueryBuilderTypesInfo", resp.data.report_types);
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteQueryBuilds][Store][Error occured while getting deleting query--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async downloadQueryBasedReports(context, payload={}){
    try {
      let resp = await axios.get(`${Constants.queryBasedReportsDownloadUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        context.commit("setQueryBuilderTypesInfo", resp.data.report_types);
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[downloadQueryBasedReports][Store][Error occured while downloading reports list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewQueryBuilder(context, payload = {}) {
    //payload : DAM Users JSON schema

    try {
      let resp = await axios.post(Constants.queryBuilderUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewQueryBuilder][Store][User add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewQueryBuilder][Store][Error occured while adding user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  

  async getQueryParamtersListFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.queryBuilderQueryParamtersUrl+'?filters=["size","duration"]', payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getQueryParamtersListFromServer][Store][Error occured while gettingstorage report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getColumneRequiredInQueryBuilder(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.columsRequiredInQueryBuilderUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getColumneRequiredInQueryBuilder][Store][Error occured while gettingstorage report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  // **************** You can replace downloadDownloadReportUrl with specific required URL and uncoment doenload report function*********************
  
  // async downloadDownloadeReportFromServer(context, payload = {}) {
  //   try {
  //     let resp = await axios.get(Constants.downloadDownloadReportUrl,payload);
  //     if (Constants.acceptedStatusCodes.includes(resp.status)) {
  //       return resp;
  //     }else {
  //       throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
  //     }
  //   } catch (error) {
  //     console.error(
  //       `[downloadDownloadeReportFromServer][Store][Error occured while getting Download Download report list--->${error}]`
  //     );
  //     if (error.response) {
  //       if (error.response.status == 401){
  //         return context.dispatch("users/logOutFromServer", {},{root:true})
  //       }
  //       else {
  //         error.response.data.statusCode = error.response.status
  //         return error.response.data
  //       }
  //     }
  //     return {}
  //   }
  // },

  

  // async getAllUsersFromServerIngest(context, payload = {}) {
  //   try {
  //     let resp = await axios.get(Constants.usersUrl, payload);
  //     if (Constants.acceptedStatusCodes.includes(resp.status)) {
  //       resp.data.statusCode = resp.status
  //       return resp.data;
  //     }else {
  //       throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
  //     }
  //   } catch (error) {
  //     console.error(
  //       `[getAllUsersFromServer][Store][Error occured while getting userslist--->${error}]`
  //     );
  //     if (error.response) {
  //       if (error.response.status == 401){
  //         return context.dispatch("logOutFromServer")
  //       }
  //       else {
  //         error.response.data.statusCode = error.response.status
  //         return error.response.data
  //       }
  //     }
  //     return {}
  //   }
  // },

};
